import { combineReducers } from "@reduxjs/toolkit";
import { authReducer, configReducer } from "@stadium/redux-utils/slices";
import orderReducer from "@slices/order";
import modalReducer from "@slices/modal";
import shopReducer from "@slices/shop";

const appReducer = combineReducers({
  config: configReducer,
  auth: authReducer,
  order: orderReducer,
  modal: modalReducer,
  shop: shopReducer,
});

const rootReducer = (state = {}, action) => appReducer(state, action) || state;

export default rootReducer;
